<template>
  <div
    class="notification-item"
    :class="{ 'notification-unseen': !isRead }"
    @click="$emit('click')"
  >
    <div class="flex-shrink-0">
      <div class="rounded-full">
        <ThemeImage
          :icon="imageNames.SUPER_AGI_LOGO_ROUND"
          alt="superagi_logo"
          class="size-6"
        />
      </div>
    </div>
    <div class="flex-1 min-w-0">
      <p class="text-sm font-medium text_color">
        Your {{ entityType === "csv" ? "CSV" : "List" }} enrichment of
        <span class="font-semibold">{{ entityName }}</span> has been completed.
      </p>
      <div class="mt-1.5 flex flex-col items-start gap-2">
        <a
          v-if="downloadUrl"
          :href="downloadUrl"
          target="_blank"
          rel="noopener noreferrer"
          class="secondary_medium inline-flex items-center rounded-lg text-sm font-semibold bg-transparent px-2"
          @click.stop
        >
          <ThemeImage
            :icon="imageNames.DOWNLOAD_GREY"
            alt="download-icon"
            class="size-4"
          />
          Download
        </a>
        <span class="text-sm secondary_color text-nowrap">{{
          formatTimestamp(createdTime, "timestamp", formatTypes.centered)
        }}</span>
      </div>
    </div>
    <div
      v-if="!isRead"
      class="flex-shrink-0 w-2 h-2 bg-blue-600 rounded-full mt-2"
    ></div>
  </div>
</template>

<script setup>
import { formatTimestamp } from "@/src/utils/dateTimeUtils.js";
import { formatTypes } from "@/src/constants/dateTimeConstants.js";
import { imageNames } from "@/src/constants/imageConstants.js";

const props = defineProps({
  entityType: {
    type: String,
    required: true,
  },
  entityName: {
    type: String,
    required: true,
  },
  entityId: {
    type: String,
    required: true,
  },
  downloadUrl: {
    type: String,
    required: true,
  },
  isRead: {
    type: Boolean,
    default: false,
  },
  createdTime: {
    type: String,
    required: true,
  },
});

defineEmits(["click"]);
</script>

<style scoped>
.notification-item {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  padding: 1rem;
  cursor: pointer;
  border-bottom: 1px solid var(--border-color);
  transition: background-color 0.2s ease-in-out;
  border-radius: 8px;
}

.notification-item:hover {
  background-color: rgba(255, 255, 255, 0.08);
}

.notification-unseen {
  background: rgba(112, 149, 235, 0.12);
}

.notification-unseen:hover {
  background:
    linear-gradient(
      0deg,
      rgba(255, 255, 255, 0.08) 0%,
      rgba(255, 255, 255, 0.08) 100%
    ),
    rgba(112, 149, 235, 0.12);
}

.download-button {
  background-color: rgb(229, 231, 235);
  color: rgb(55, 65, 81);
  transition: background-color 0.2s ease;
}

.download-button:hover {
  background-color: rgb(209, 213, 219);
}

p {
  word-break: break-word;
  overflow-wrap: break-word;
}
</style>
